<template>
  <div>
    <Loading v-if="loading" />

    <div v-else>
      <AddComment :work-order-id="workOrderId" @added="onCommentAdded" />

      <div v-if="!activityLog?.length" class="py-6">
        <EHeroContent
          icon="folder-open"
          :title="t(useTranslationPath(callerPath, 'emptyTitle'))"
          :description="t(useTranslationPath(callerPath, 'emptyDescription'))"
        />
      </div>
      <EActivityLog v-else>
        <EActivityLogGroup
          v-for="(group, groupIndex) in activityLog"
          :key="groupIndex"
          :title="group.title"
        >
          <EActivityLogItem
            v-for="(item, itemIndex) in group.items"
            :key="itemIndex"
            :variant="item.variant"
            :icon="item.icon"
            :time="item.time"
            :title="item.title"
            :name="item.name"
          >
            <EActivityLogItemRow
              v-for="(row, rowIndex) in item.rows"
              :key="rowIndex"
              :label="row.label"
              :from="row.from"
              :to="row.to"
              :clickable="row.clickable"
              @to-clicked="row.toClicked ? row.toClicked() : null"
            />
          </EActivityLogItem>
        </EActivityLogGroup>
      </EActivityLog>
    </div>
  </div>
</template>

<script setup>
import Loading from '@/components/Loading.vue'
import AddComment from '@/components/WorkOrder/Updates/AddComment.vue'
import { useResolveWorkOrderEvents } from '@/composables/useResolveWorkOrderEvents.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { getActivityLog } from '@/utils/getActivityLog.js'
import {
  EActivityLog,
  EActivityLogGroup,
  EActivityLogItem,
  EActivityLogItemRow,
  EHeroContent,
} from '@expansivefm/eds'
import { inject, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  workOrderId: {
    type: Number,
    required: true,
  },
})

const appStore = useAppStore()
const callerPath = 'components.workOrder.updates'
const loading = ref(false)
const events = ref([])
const activityLog = ref([])
const { t } = useI18n()
const axios = inject('$axios')

onMounted(async () => {
  loading.value = true
  await fetchEvents()
  loading.value = false
})

// todo: move this over to v2 once it's available
const fetchEvents = async () => {
  await axios
    .get(`${appStore.apiUrl}/api/work_order_event?filter[work_order_id]=${props.workOrderId}`)
    .then(async ({ data: { data } }) => {
      events.value = data
    })

  // resolve the work order events (and comments) to get the correct data structure
  events.value = await useResolveWorkOrderEvents(t, events.value)

  // generate the activity log groups/items from the resolved events
  activityLog.value = await getActivityLog(t, events.value)
}

const onCommentAdded = async () => {
  loading.value = true
  await fetchEvents()
  loading.value = false
}
</script>
